/**
 * @generated SignedSource<<23c6063cb28a3a82e3e0c16276414fc2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type usePreloadedDuties_item$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "usePreloadedDuties_item";
};
export type usePreloadedDuties_item$key = {
  readonly " $data"?: usePreloadedDuties_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"usePreloadedDuties_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "usePreloadedDuties_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "49c330b3200ec9a60efb43b6ab0f4ba6";

export default node;
